(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    if (!document.documentElement.dataset.sandsSizeButtonsReady) {
    document.documentElement.dataset.sandsSizeButtonsReady = 'true';

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sands-size-value]');
      if (!button || button.disabled) return;

      const option = button.closest('.ProductForm__Option--sizeButtons');
      const activator = option && option.querySelector('.ProductForm__Item');
      const popoverId = activator && activator.getAttribute('aria-controls');
      const popover = popoverId && document.getElementById(popoverId);
      if (!popover) return;

      const value = button.dataset.sandsSizeValue;
      const originalButtons = popover.querySelectorAll('[data-action="select-value"]');
      let originalButton = null;

      originalButtons.forEach((candidate) => {
        if (candidate.getAttribute('data-value') === value) originalButton = candidate;
      });

      if (!originalButton) return;
      originalButton.click();

      option.querySelectorAll('[data-sands-size-value]').forEach((candidate) => {
        const selected = candidate === button;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
